function initFeaturedKits(sectionId, options = {}) {
  const section = document.getElementById(sectionId);
  if (!section) return;

  const desktopLayout = options.desktopLayout || 'slider';
  const mobileLayout = options.mobileLayout || 'slider';
  const seeAllLayout = options.seeAllLayout || 'text';

  const elements = {
    buttons: section.querySelectorAll('.selector-collection-button'),
    slides: section.querySelectorAll('[data-slide]'),
    gridItems: section.querySelectorAll('[data-collection]'),
    gridContainers: section.querySelectorAll('.featured-products-grid'),
  };

  const splideInstances = {};
  const mobileSeeAllButtons = {};

  const initSplideForCollection = (collectionHandle) => {
    const isDesktopView = window.innerWidth >= 1024;
    const slides = Array.from(elements.slides).filter((slide) => {
      if (slide.dataset.collection !== collectionHandle) return false;

      if (isDesktopView) {
        return slide.closest('.tw-hidden.lg\\:tw-block');
      } else {
        return slide.closest('.lg\\:tw-hidden');
      }
    });

    if (!slides.length) return;

    if (splideInstances[collectionHandle]) return;

    let mobileSeeAll = null;

    // Only create mobile see all button if seeAllLayout is 'button'
    if (seeAllLayout === 'button') {
      mobileSeeAll = document.createElement('a');
      mobileSeeAll.classList.add(
        'tw-text-base',
        'tw-block',
        'lg:tw-hidden',
        'tw-border-2',
        'goshop-mobile-see-all-button-colors',
        'tw-rounded-md',
        'tw-py-3',
        'tw-w-full',
        'tw-text-center',
        'tw-font-semibold',
        'tw-mt-7'
      );
      mobileSeeAll.href = `/collections/${collectionHandle}`;
      mobileSeeAll.textContent = 'Ver todos';
      mobileSeeAll.dataset.collection = collectionHandle;
    }

    const container = document.createElement('div');
    container.classList.add('splide', 'featured-collections-splide');
    container.dataset.collection = collectionHandle;

    const track = document.createElement('div');
    track.classList.add('splide__track');

    const list = document.createElement('ul');
    list.classList.add('splide__list');

    slides.forEach((slide) => {
      slide.style.display = '';
      list.appendChild(slide);
    });

    track.appendChild(list);
    container.appendChild(track);
    section.appendChild(container);

    if (mobileSeeAll) {
      mobileSeeAllButtons[collectionHandle] = mobileSeeAll;
      section.appendChild(mobileSeeAll);
    }

    const splideInstance = new Splide(container, {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      drag: 'free',
      lazyload: 'sequential',
      gap: '30px',
      snap: false,
      focus: 'center',
      pagination: false,
      arrows: true,
      easing: 'cubic-bezier(.38,0,.57,1)',
      padding: {
        right: '10%',
      },
      breakpoints: {
        767: {
          gap: '12px',
          perPage: 1,
          perMove: 1,
        },
        1024: {
          gap: '20px',
          perPage: 2,
          perMove: 2,
          drag: 'free',
        },
      },
      classes: {
        arrow: 'splide__arrow !tw-bg-white',
        prev: 'splide__arrow--prev !tw-left-[0rem]',
        next: 'splide__arrow--next !tw-right-[0rem]',
      },
    }).mount();

    splideInstances[collectionHandle] = splideInstance;
    splideInstance.go(0);
  };

  const handleGridCollectionDisplay = (selectedHandle) => {
    elements.gridItems.forEach((item) => {
      if (item.classList.contains('featured-product-grid-item')) {
        item.style.display = item.dataset.collection === selectedHandle ? 'flex' : 'none';
      }
    });
  };

  const handleCollectionChange = (button) => {
    const selectedHandle = button.dataset.collection;

    elements.buttons.forEach((btn) => {
      btn.classList.remove('selected');
      if (btn.dataset.collection === selectedHandle) {
        btn.classList.add('selected');
      }
    });

    const isDesktopView = window.innerWidth >= 1024;
    const currentLayout = isDesktopView ? desktopLayout : mobileLayout;

    if (currentLayout === 'slider') {
      Object.values(splideInstances).forEach((instance) => {
        instance.root.style.display = 'none';
      });

      Object.values(mobileSeeAllButtons).forEach((btn) => {
        if (btn) btn.style.display = 'none';
      });

      const selectedInstance = splideInstances[selectedHandle];
      if (selectedInstance) {
        selectedInstance.root.style.display = 'block';
        selectedInstance.go(0);
        if (mobileSeeAllButtons[selectedHandle]) {
          mobileSeeAllButtons[selectedHandle].style.display = isDesktopView ? 'none' : 'block';
        }
      } else {
        initSplideForCollection(selectedHandle);
        const newInstance = splideInstances[selectedHandle];
        if (newInstance) {
          newInstance.root.style.display = 'block';
          newInstance.go(0);
          if (mobileSeeAllButtons[selectedHandle]) {
            mobileSeeAllButtons[selectedHandle].style.display = isDesktopView ? 'none' : 'block';
          }
        }
      }
    } else {
      handleGridCollectionDisplay(selectedHandle);
    }
  };

  const uniqueCollections = new Set(Array.from(elements.slides).map((slide) => slide.dataset.collection));
  uniqueCollections.forEach((collectionHandle) => {
    const isDesktopView = window.innerWidth >= 1024;
    const currentLayout = isDesktopView ? desktopLayout : mobileLayout;

    if (currentLayout === 'slider') {
      initSplideForCollection(collectionHandle);
    }
  });

  if (desktopLayout === 'grid' || mobileLayout === 'grid') {
    const firstCollection = elements.buttons[0]?.dataset.collection;
    if (firstCollection) {
      handleGridCollectionDisplay(firstCollection);
    }
  }

  section.addEventListener('click', (e) => {
    const button = e.target.closest('.selector-collection-button');
    if (button) handleCollectionChange(button);
  });

  const firstButton = elements.buttons[0];
  if (firstButton) handleCollectionChange(firstButton);

  let lastWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    const currentWidth = window.innerWidth;
    const wasDesktop = lastWidth >= 1024;
    const isDesktop = currentWidth >= 1024;

    if (wasDesktop !== isDesktop) {
      const firstButton = elements.buttons[0];
      if (firstButton) handleCollectionChange(firstButton);
    }

    lastWidth = currentWidth;
  });
}
